var _g, _g2, _g3, _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNpsExplanation = function SvgNpsExplanation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_42_1",
    "data-name": "Componente 42 \\u2013 1",
    width: 332,
    height: 126.434,
    viewBox: "0 0 332 126.434",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5762",
    "data-name": "Grupo 5762"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(32.337 15)",
    fill: "#fd4949",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(4.588 15)",
    fill: "#fd4949",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(61.736 15)",
    fill: "#fd4949",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(89.664 15)",
    fill: "#fd4949",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(119.999 15)",
    fill: "#fd4949",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(148.461 15)",
    fill: "#fd4949",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": 6,
    transform: "translate(177.125 15)",
    fill: "#fd4949",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(214.182 15)",
    fill: "#fcbd2f",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(242.846 15)",
    fill: "#fcbd2f",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    id: "_9",
    "data-name": 9,
    transform: "translate(279.064 15)",
    fill: "#3acb16",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9")), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": 10,
    transform: "translate(303.318 15)",
    fill: "#3acb16",
    fontSize: 16,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5752",
    "data-name": "Grupo 5752",
    transform: "translate(28.663 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5772",
    "data-name": "Grupo 5772",
    transform: "translate(0 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-2",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-2",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5754",
    "data-name": "Grupo 5754",
    transform: "translate(57.326 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-3",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-3",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5755",
    "data-name": "Grupo 5755",
    transform: "translate(85.99 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-4",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-4",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5756",
    "data-name": "Grupo 5756",
    transform: "translate(115.388 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-5",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-5",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5757",
    "data-name": "Grupo 5757",
    transform: "translate(144.052 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-6",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-6",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5758",
    "data-name": "Grupo 5758",
    transform: "translate(172.715 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-7",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-7",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5759",
    "data-name": "Grupo 5759",
    transform: "translate(209.773 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-8",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fcbd2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-8",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fcbd2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5760",
    "data-name": "Grupo 5760",
    transform: "translate(238.436 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-9",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#fcbd2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-9",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#fcbd2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5761",
    "data-name": "Grupo 5761",
    transform: "translate(275.389 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-10",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#3acb16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-10",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#3acb16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5753",
    "data-name": "Grupo 5753",
    transform: "translate(304.053 27.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-11",
    "data-name": "Caminho 4715",
    d: "M492.82,235.21a5.608,5.608,0,1,0-5.608,5.608A5.615,5.615,0,0,0,492.82,235.21Z",
    transform: "translate(-477.381 -229.602)",
    fill: "#3acb16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-11",
    "data-name": "Caminho 4716",
    d: "M453.907,294.394h19.659a9.891,9.891,0,0,0-19.66,0Z",
    transform: "translate(-453.906 -273.08)",
    fill: "#3acb16"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5766",
    "data-name": "Grupo 5766",
    transform: "translate(0.227 49.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4720",
    "data-name": "Caminho 4720",
    d: "M2.32-2.425q.1.009.235.014t.319,0a2.124,2.124,0,0,0,1.6-.545A2.087,2.087,0,0,0,5-4.457,2.113,2.113,0,0,0,4.5-5.98,2.11,2.11,0,0,0,2.921-6.5q-.148,0-.3,0a2.88,2.88,0,0,0-.3.023ZM6.485-4.457a3.741,3.741,0,0,1-.259,1.45,2.685,2.685,0,0,1-.734,1.025,3.131,3.131,0,0,1-1.159.609,5.372,5.372,0,0,1-1.533.2q-.388,0-.9-.032A7.393,7.393,0,0,1,.88-1.336V-7.568a8.486,8.486,0,0,1,1.039-.125q.54-.032.928-.032a5.6,5.6,0,0,1,1.491.185,3.05,3.05,0,0,1,1.15.582,2.585,2.585,0,0,1,.739,1.016A3.848,3.848,0,0,1,6.485-4.457Zm1.2,3.2v-6.4h4.321v1.21H9.125v1.256h2.558V-4H9.125v1.542h3.093v1.21Zm10.341-6.4v1.228H16.1v5.171h-1.44V-6.423h-1.93V-7.651Zm2.8-.074a3.966,3.966,0,0,1,2.207.512A1.781,1.781,0,0,1,23.8-5.62a1.8,1.8,0,0,1-.309,1.094,2.037,2.037,0,0,1-.891.66q.194.24.406.549t.42.646q.208.337.4.7t.36.716H22.569l-.355-.637q-.18-.323-.369-.628t-.374-.577q-.185-.272-.369-.494H20.39v2.336H18.95V-7.559a8.166,8.166,0,0,1,.974-.129Q20.427-7.725,20.824-7.725ZM20.907-6.5q-.157,0-.282.009l-.235.018v1.736H20.8a2.453,2.453,0,0,0,1.163-.2.734.734,0,0,0,.351-.693.7.7,0,0,0-.355-.669A2.2,2.2,0,0,0,20.907-6.5Zm8.772,5.245q-.1-.332-.226-.683t-.245-.7H26.715q-.12.351-.245.7t-.226.683h-1.5q.36-1.034.683-1.911t.632-1.653q.309-.776.609-1.473T27.3-7.651h1.376q.314.665.619,1.362t.614,1.473q.309.776.632,1.653t.683,1.911ZM27.952-6.2q-.046.139-.139.379l-.212.554q-.12.314-.263.693t-.291.794h1.819q-.148-.416-.286-.794t-.263-.693q-.125-.314-.217-.554T27.952-6.2Zm8.089-1.45v1.228h-1.93v5.171h-1.44V-6.423h-1.93V-7.651Zm1.921,3.195a2.908,2.908,0,0,0,.115.849,1.941,1.941,0,0,0,.332.651,1.471,1.471,0,0,0,.531.42,1.673,1.673,0,0,0,.72.148,1.681,1.681,0,0,0,.716-.148,1.461,1.461,0,0,0,.536-.42,1.94,1.94,0,0,0,.332-.651,2.908,2.908,0,0,0,.115-.849,2.955,2.955,0,0,0-.115-.854,1.935,1.935,0,0,0-.332-.656,1.461,1.461,0,0,0-.536-.42,1.681,1.681,0,0,0-.716-.148,1.63,1.63,0,0,0-.72.152,1.517,1.517,0,0,0-.531.425,1.935,1.935,0,0,0-.332.656A2.921,2.921,0,0,0,37.962-4.457Zm4.884,0A3.938,3.938,0,0,1,42.6-3.011a2.971,2.971,0,0,1-.669,1.043,2.749,2.749,0,0,1-1.011.632,3.673,3.673,0,0,1-1.26.212,3.58,3.58,0,0,1-1.237-.212,2.845,2.845,0,0,1-1.016-.632,2.957,2.957,0,0,1-.683-1.043,3.872,3.872,0,0,1-.249-1.445A3.749,3.749,0,0,1,36.733-5.9a3.079,3.079,0,0,1,.7-1.048,2.867,2.867,0,0,1,1.016-.637A3.488,3.488,0,0,1,39.66-7.8a3.58,3.58,0,0,1,1.237.212,2.814,2.814,0,0,1,1.016.637A3.005,3.005,0,0,1,42.6-5.9,3.872,3.872,0,0,1,42.846-4.457Zm3.075-3.269a3.966,3.966,0,0,1,2.207.512,1.781,1.781,0,0,1,.766,1.593,1.8,1.8,0,0,1-.309,1.094,2.037,2.037,0,0,1-.891.66q.194.24.406.549t.42.646q.208.337.4.7t.36.716H47.666L47.31-1.89q-.18-.323-.369-.628t-.374-.577q-.185-.272-.369-.494h-.711v2.336h-1.44V-7.559a8.166,8.166,0,0,1,.974-.129Q45.524-7.725,45.921-7.725ZM46-6.5q-.157,0-.282.009l-.235.018v1.736h.406a2.453,2.453,0,0,0,1.163-.2.734.734,0,0,0,.351-.693.7.7,0,0,0-.355-.669A2.2,2.2,0,0,0,46-6.5Zm4.2,5.245v-6.4h4.321v1.21H51.646v1.256H54.2V-4H51.646v1.542h3.093v1.21Zm7.341-1.1a2.078,2.078,0,0,0,.5-.051.928.928,0,0,0,.319-.139.464.464,0,0,0,.166-.208.741.741,0,0,0,.046-.268.619.619,0,0,0-.3-.522,4.222,4.222,0,0,0-1.016-.448q-.314-.111-.628-.254a2.314,2.314,0,0,1-.563-.36,1.723,1.723,0,0,1-.406-.526,1.648,1.648,0,0,1-.157-.753,1.863,1.863,0,0,1,.166-.8,1.705,1.705,0,0,1,.471-.6,2.155,2.155,0,0,1,.739-.383,3.316,3.316,0,0,1,.979-.134,3.986,3.986,0,0,1,1.117.139,3.992,3.992,0,0,1,.776.3L59.346-6.22a3.935,3.935,0,0,0-.6-.245,2.579,2.579,0,0,0-.789-.106,1.448,1.448,0,0,0-.743.143.483.483,0,0,0-.226.439.507.507,0,0,0,.083.3.808.808,0,0,0,.235.217,2.072,2.072,0,0,0,.351.175q.2.078.439.162.5.185.868.365a2.318,2.318,0,0,1,.614.42,1.522,1.522,0,0,1,.365.563,2.263,2.263,0,0,1,.12.785,1.667,1.667,0,0,1-.628,1.39,3.03,3.03,0,0,1-1.893.494,5.244,5.244,0,0,1-.766-.051,4.946,4.946,0,0,1-.6-.125,3.469,3.469,0,0,1-.452-.157,3.435,3.435,0,0,1-.319-.157l.406-1.145a3.622,3.622,0,0,0,.706.282A3.664,3.664,0,0,0,57.546-2.351Z",
    transform: "translate(65.797 32.19)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4719",
    "data-name": "Caminho 4719",
    d: "M5.174-1.253q-.619-1.1-1.339-2.17A22.052,22.052,0,0,0,2.3-5.444v4.192H.88v-6.4H2.053q.3.3.674.748t.753.946q.383.5.762,1.043t.711,1.039V-7.651H6.383v6.4Zm2.687,0v-6.4h4.321v1.21H9.3v1.256h2.558V-4H9.3v1.542h3.093v1.21Zm8.1.129a3.223,3.223,0,0,1-1.163-.189,2.167,2.167,0,0,1-.808-.526,2.1,2.1,0,0,1-.471-.8,3.3,3.3,0,0,1-.152-1.03v-3.98H14.8v3.86a2.171,2.171,0,0,0,.088.66,1.217,1.217,0,0,0,.24.443.857.857,0,0,0,.369.245,1.467,1.467,0,0,0,.476.074,1.164,1.164,0,0,0,.854-.323,1.508,1.508,0,0,0,.328-1.1v-3.86H18.6v3.98a3.254,3.254,0,0,1-.157,1.034,2.116,2.116,0,0,1-.48.808,2.153,2.153,0,0,1-.822.522A3.4,3.4,0,0,1,15.958-1.123ZM24.73-7.651v1.228H22.8v5.171H21.36V-6.423H19.43V-7.651Zm2.8-.074a3.966,3.966,0,0,1,2.207.512A1.781,1.781,0,0,1,30.5-5.62a1.8,1.8,0,0,1-.309,1.094,2.037,2.037,0,0,1-.891.66q.194.24.406.549t.42.646q.208.337.4.7t.36.716H29.273l-.355-.637q-.18-.323-.369-.628t-.374-.577q-.185-.272-.369-.494h-.711v2.336h-1.44V-7.559a8.166,8.166,0,0,1,.974-.129Q27.131-7.725,27.528-7.725ZM27.611-6.5q-.157,0-.282.009l-.235.018v1.736H27.5a2.453,2.453,0,0,0,1.163-.2.734.734,0,0,0,.351-.693.7.7,0,0,0-.355-.669A2.2,2.2,0,0,0,27.611-6.5Zm5.245,2.041a2.908,2.908,0,0,0,.115.849,1.941,1.941,0,0,0,.332.651,1.471,1.471,0,0,0,.531.42,1.673,1.673,0,0,0,.72.148,1.681,1.681,0,0,0,.716-.148,1.461,1.461,0,0,0,.536-.42,1.941,1.941,0,0,0,.332-.651,2.908,2.908,0,0,0,.115-.849,2.956,2.956,0,0,0-.115-.854,1.935,1.935,0,0,0-.332-.656,1.461,1.461,0,0,0-.536-.42,1.681,1.681,0,0,0-.716-.148,1.63,1.63,0,0,0-.72.152,1.517,1.517,0,0,0-.531.425,1.935,1.935,0,0,0-.332.656A2.921,2.921,0,0,0,32.855-4.457Zm4.884,0A3.938,3.938,0,0,1,37.5-3.011a2.971,2.971,0,0,1-.669,1.043,2.748,2.748,0,0,1-1.011.632,3.673,3.673,0,0,1-1.26.212,3.58,3.58,0,0,1-1.237-.212A2.845,2.845,0,0,1,32.3-1.968a2.957,2.957,0,0,1-.683-1.043,3.872,3.872,0,0,1-.249-1.445A3.749,3.749,0,0,1,31.627-5.9a3.079,3.079,0,0,1,.7-1.048,2.867,2.867,0,0,1,1.016-.637A3.488,3.488,0,0,1,34.554-7.8a3.58,3.58,0,0,1,1.237.212,2.814,2.814,0,0,1,1.016.637A3.005,3.005,0,0,1,37.491-5.9,3.872,3.872,0,0,1,37.74-4.457Zm2.945,2.105a2.077,2.077,0,0,0,.5-.051.928.928,0,0,0,.319-.139.464.464,0,0,0,.166-.208.741.741,0,0,0,.046-.268.619.619,0,0,0-.3-.522,4.222,4.222,0,0,0-1.016-.448q-.314-.111-.628-.254a2.314,2.314,0,0,1-.563-.36,1.723,1.723,0,0,1-.406-.526,1.648,1.648,0,0,1-.157-.753,1.863,1.863,0,0,1,.166-.8,1.705,1.705,0,0,1,.471-.6,2.155,2.155,0,0,1,.739-.383,3.316,3.316,0,0,1,.979-.134,3.985,3.985,0,0,1,1.117.139,3.992,3.992,0,0,1,.776.3L42.486-6.22a3.935,3.935,0,0,0-.6-.245,2.579,2.579,0,0,0-.789-.106,1.448,1.448,0,0,0-.743.143.483.483,0,0,0-.226.439.507.507,0,0,0,.083.3.808.808,0,0,0,.235.217A2.072,2.072,0,0,0,40.8-5.3q.2.078.439.162.5.185.868.365a2.318,2.318,0,0,1,.614.42,1.522,1.522,0,0,1,.365.563,2.263,2.263,0,0,1,.12.785,1.667,1.667,0,0,1-.628,1.39,3.03,3.03,0,0,1-1.893.494,5.244,5.244,0,0,1-.766-.051,4.946,4.946,0,0,1-.6-.125,3.469,3.469,0,0,1-.452-.157,3.435,3.435,0,0,1-.319-.157l.406-1.145a3.622,3.622,0,0,0,.706.282A3.664,3.664,0,0,0,40.685-2.351Z",
    transform: "translate(211.285 32.19)",
    fill: "#fcbd2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4718",
    "data-name": "Caminho 4718",
    d: "M2.8-7.725a4,4,0,0,1,2.2.5,1.824,1.824,0,0,1,.766,1.648,1.849,1.849,0,0,1-.776,1.667,4.014,4.014,0,0,1-2.216.512H2.32v2.142H.88V-7.559a8.149,8.149,0,0,1,1-.129Q2.4-7.725,2.8-7.725ZM2.893-6.5q-.157,0-.309.009l-.263.018v1.847h.452a2.452,2.452,0,0,0,1.126-.2.781.781,0,0,0,.379-.757.908.908,0,0,0-.1-.443A.737.737,0,0,0,3.9-6.308a1.248,1.248,0,0,0-.439-.148A3.622,3.622,0,0,0,2.893-6.5ZM8.7-7.725a3.966,3.966,0,0,1,2.207.512,1.781,1.781,0,0,1,.766,1.593,1.8,1.8,0,0,1-.309,1.094,2.037,2.037,0,0,1-.891.66q.194.24.406.549t.42.646q.208.337.4.7t.36.716H10.446L10.09-1.89q-.18-.323-.369-.628t-.374-.577q-.185-.272-.369-.494H8.267v2.336H6.826V-7.559A8.166,8.166,0,0,1,7.8-7.688Q8.3-7.725,8.7-7.725ZM8.784-6.5q-.157,0-.282.009l-.235.018v1.736h.406a2.453,2.453,0,0,0,1.163-.2.734.734,0,0,0,.351-.693A.7.7,0,0,0,9.832-6.3,2.2,2.2,0,0,0,8.784-6.5Zm5.245,2.041a2.908,2.908,0,0,0,.115.849,1.94,1.94,0,0,0,.332.651,1.471,1.471,0,0,0,.531.42,1.673,1.673,0,0,0,.72.148,1.681,1.681,0,0,0,.716-.148,1.461,1.461,0,0,0,.536-.42,1.94,1.94,0,0,0,.332-.651,2.908,2.908,0,0,0,.115-.849,2.955,2.955,0,0,0-.115-.854,1.935,1.935,0,0,0-.332-.656,1.461,1.461,0,0,0-.536-.42,1.681,1.681,0,0,0-.716-.148,1.63,1.63,0,0,0-.72.152,1.517,1.517,0,0,0-.531.425,1.935,1.935,0,0,0-.332.656A2.921,2.921,0,0,0,14.028-4.457Zm4.884,0a3.938,3.938,0,0,1-.245,1.445A2.971,2.971,0,0,1,18-1.968a2.748,2.748,0,0,1-1.011.632,3.673,3.673,0,0,1-1.26.212,3.58,3.58,0,0,1-1.237-.212,2.845,2.845,0,0,1-1.016-.632,2.957,2.957,0,0,1-.683-1.043,3.872,3.872,0,0,1-.249-1.445A3.749,3.749,0,0,1,12.8-5.9a3.079,3.079,0,0,1,.7-1.048,2.867,2.867,0,0,1,1.016-.637A3.488,3.488,0,0,1,15.727-7.8a3.58,3.58,0,0,1,1.237.212,2.814,2.814,0,0,1,1.016.637A3.005,3.005,0,0,1,18.664-5.9,3.872,3.872,0,0,1,18.913-4.457Zm2.9-3.195q.166.3.383.753t.452.97q.235.522.466,1.066l.434,1.025.434-1.025q.231-.545.466-1.066T24.9-6.9q.217-.448.383-.753H26.6q.092.637.171,1.427T26.9-4.581q.06.854.111,1.713T27.1-1.253H25.7q-.028-.933-.074-2.031T25.487-5.5l-.369.859q-.2.471-.4.942t-.383.9q-.185.429-.314.734H23.013q-.129-.3-.314-.734t-.383-.9q-.2-.471-.4-.942L21.544-5.5q-.092,1.117-.139,2.216t-.074,2.031h-1.4q.037-.757.088-1.616t.111-1.713q.06-.854.139-1.644t.171-1.427Zm7.793,3.195a2.908,2.908,0,0,0,.115.849,1.941,1.941,0,0,0,.332.651,1.471,1.471,0,0,0,.531.42,1.673,1.673,0,0,0,.72.148,1.681,1.681,0,0,0,.716-.148,1.461,1.461,0,0,0,.536-.42,1.94,1.94,0,0,0,.332-.651A2.908,2.908,0,0,0,33-4.457a2.955,2.955,0,0,0-.115-.854,1.935,1.935,0,0,0-.332-.656,1.461,1.461,0,0,0-.536-.42,1.681,1.681,0,0,0-.716-.148,1.63,1.63,0,0,0-.72.152,1.517,1.517,0,0,0-.531.425,1.935,1.935,0,0,0-.332.656A2.921,2.921,0,0,0,29.605-4.457Zm4.885,0a3.938,3.938,0,0,1-.245,1.445,2.971,2.971,0,0,1-.669,1.043,2.749,2.749,0,0,1-1.011.632,3.673,3.673,0,0,1-1.26.212,3.58,3.58,0,0,1-1.237-.212,2.845,2.845,0,0,1-1.016-.632,2.957,2.957,0,0,1-.683-1.043,3.872,3.872,0,0,1-.249-1.445A3.749,3.749,0,0,1,28.377-5.9a3.079,3.079,0,0,1,.7-1.048,2.867,2.867,0,0,1,1.016-.637A3.488,3.488,0,0,1,31.3-7.8a3.58,3.58,0,0,1,1.237.212,2.814,2.814,0,0,1,1.016.637A3.005,3.005,0,0,1,34.24-5.9,3.872,3.872,0,0,1,34.49-4.457Zm5.734-3.195v1.228h-1.93v5.171h-1.44V-6.423h-1.93V-7.651Zm1.921,3.195a2.908,2.908,0,0,0,.115.849,1.941,1.941,0,0,0,.332.651,1.471,1.471,0,0,0,.531.42,1.673,1.673,0,0,0,.72.148,1.681,1.681,0,0,0,.716-.148,1.461,1.461,0,0,0,.536-.42,1.94,1.94,0,0,0,.332-.651,2.908,2.908,0,0,0,.115-.849,2.956,2.956,0,0,0-.115-.854,1.935,1.935,0,0,0-.332-.656,1.461,1.461,0,0,0-.536-.42,1.681,1.681,0,0,0-.716-.148,1.63,1.63,0,0,0-.72.152,1.517,1.517,0,0,0-.531.425,1.935,1.935,0,0,0-.332.656A2.921,2.921,0,0,0,42.144-4.457Zm4.884,0a3.938,3.938,0,0,1-.245,1.445,2.971,2.971,0,0,1-.669,1.043,2.748,2.748,0,0,1-1.011.632,3.673,3.673,0,0,1-1.26.212,3.58,3.58,0,0,1-1.237-.212,2.845,2.845,0,0,1-1.016-.632,2.957,2.957,0,0,1-.683-1.043,3.872,3.872,0,0,1-.249-1.445A3.749,3.749,0,0,1,40.916-5.9a3.079,3.079,0,0,1,.7-1.048,2.867,2.867,0,0,1,1.016-.637A3.488,3.488,0,0,1,43.843-7.8a3.58,3.58,0,0,1,1.237.212A2.814,2.814,0,0,1,46.1-6.95,3.005,3.005,0,0,1,46.779-5.9,3.872,3.872,0,0,1,47.029-4.457ZM50.1-7.725a3.966,3.966,0,0,1,2.207.512,1.781,1.781,0,0,1,.766,1.593,1.8,1.8,0,0,1-.309,1.094,2.038,2.038,0,0,1-.891.66q.194.24.406.549t.42.646q.208.337.4.7t.36.716H51.849l-.355-.637q-.18-.323-.369-.628t-.374-.577q-.185-.272-.369-.494H49.67v2.336h-1.44V-7.559a8.166,8.166,0,0,1,.974-.129Q49.706-7.725,50.1-7.725ZM50.187-6.5q-.157,0-.282.009l-.235.018v1.736h.406a2.453,2.453,0,0,0,1.163-.2.734.734,0,0,0,.351-.693.7.7,0,0,0-.355-.669A2.2,2.2,0,0,0,50.187-6.5Zm4.2,5.245v-6.4h4.321v1.21H55.828v1.256h2.558V-4H55.828v1.542h3.093v1.21Zm7.341-1.1a2.078,2.078,0,0,0,.5-.051.928.928,0,0,0,.319-.139.464.464,0,0,0,.166-.208.741.741,0,0,0,.046-.268.619.619,0,0,0-.3-.522,4.222,4.222,0,0,0-1.016-.448q-.314-.111-.628-.254a2.314,2.314,0,0,1-.563-.36,1.723,1.723,0,0,1-.406-.526,1.648,1.648,0,0,1-.157-.753,1.863,1.863,0,0,1,.166-.8,1.7,1.7,0,0,1,.471-.6,2.155,2.155,0,0,1,.739-.383,3.316,3.316,0,0,1,.979-.134,3.985,3.985,0,0,1,1.117.139,3.992,3.992,0,0,1,.776.3L63.529-6.22a3.936,3.936,0,0,0-.6-.245,2.579,2.579,0,0,0-.789-.106,1.448,1.448,0,0,0-.743.143.483.483,0,0,0-.226.439.507.507,0,0,0,.083.3.808.808,0,0,0,.235.217,2.072,2.072,0,0,0,.351.175q.2.078.439.162.5.185.868.365a2.318,2.318,0,0,1,.614.42,1.521,1.521,0,0,1,.365.563,2.263,2.263,0,0,1,.12.785,1.667,1.667,0,0,1-.628,1.39,3.03,3.03,0,0,1-1.893.494,5.244,5.244,0,0,1-.766-.051,4.946,4.946,0,0,1-.6-.125,3.469,3.469,0,0,1-.452-.157,3.436,3.436,0,0,1-.319-.157l.406-1.145a3.622,3.622,0,0,0,.706.282A3.664,3.664,0,0,0,61.728-2.351Z",
    transform: "translate(267.525 32.19)",
    fill: "#3acb23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5763",
    "data-name": "Grupo 5763",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_252",
    "data-name": "Linha 252",
    x2: 192.539,
    transform: "translate(0 9.743)",
    fill: "none",
    stroke: "#fd4949",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4717",
    "data-name": "Caminho 4717",
    d: "M0,0H12.591V12.591H0Z",
    transform: "translate(87.868 8.903) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4717_-_Contorno",
    "data-name": "Caminho 4717 - Contorno",
    d: "M1.679,1.679v9.233h9.233L1.679,1.679M0,0,12.591,12.591H0Z",
    transform: "translate(87.868 8.903) rotate(-45)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5764",
    "data-name": "Grupo 5764",
    transform: "translate(209.328 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_252-2",
    "data-name": "Linha 252",
    x2: 48.654,
    transform: "translate(0 9.743)",
    fill: "none",
    stroke: "#fcbd2f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4717-2",
    "data-name": "Caminho 4717",
    d: "M0,0H12.591V12.591H0Z",
    transform: "translate(15.513 8.903) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4717_-_Contorno-2",
    "data-name": "Caminho 4717 - Contorno",
    d: "M1.679,1.679v9.233h9.233L1.679,1.679M0,0,12.591,12.591H0Z",
    transform: "translate(15.513 8.903) rotate(-45)",
    fill: "#fcbd2f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5765",
    "data-name": "Grupo 5765",
    transform: "translate(274.77 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_252-3",
    "data-name": "Linha 252",
    x2: 48.654,
    transform: "translate(0 9.743)",
    fill: "none",
    stroke: "#3acb23",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4717-3",
    "data-name": "Caminho 4717",
    d: "M0,0H12.591V12.591H0Z",
    transform: "translate(15.513 8.903) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4717_-_Contorno-3",
    "data-name": "Caminho 4717 - Contorno",
    d: "M1.679,1.679v9.233h9.233L1.679,1.679M0,0,12.591,12.591H0Z",
    transform: "translate(15.513 8.903) rotate(-45)",
    fill: "#3acb23"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5767",
    "data-name": "Grupo 5767",
    transform: "translate(72.26 107.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4721",
    "data-name": "Caminho 4721",
    d: "M61.118-17.7a14.753,14.753,0,0,1,1.741-.364,14.306,14.306,0,0,1,2.238-.169,5.452,5.452,0,0,1,1.981.311,2.975,2.975,0,0,1,1.252.879,3.426,3.426,0,0,1,.657,1.35,7.182,7.182,0,0,1,.2,1.741v5.276H66.536v-4.956a3.568,3.568,0,0,0-.338-1.812,1.377,1.377,0,0,0-1.261-.533q-.284,0-.6.027t-.568.062v7.212H61.118Zm16.752.036a4.065,4.065,0,0,1-.258,1.492,3.2,3.2,0,0,1-.711,1.11,3.125,3.125,0,0,1-1.093.7,3.84,3.84,0,0,1-1.4.249A3.84,3.84,0,0,1,73-14.36a3.218,3.218,0,0,1-1.1-.7,3.131,3.131,0,0,1-.719-1.11,4.064,4.064,0,0,1-.258-1.492,4.188,4.188,0,0,1,.258-1.519,3.206,3.206,0,0,1,.719-1.128,3.153,3.153,0,0,1,1.1-.711,3.84,3.84,0,0,1,1.4-.249,3.84,3.84,0,0,1,1.4.249,3.063,3.063,0,0,1,1.093.711,3.273,3.273,0,0,1,.711,1.128A4.189,4.189,0,0,1,77.87-17.664Zm-2.025,0a2.161,2.161,0,0,0-.373-1.341,1.261,1.261,0,0,0-1.066-.489,1.292,1.292,0,0,0-1.066.489,2.091,2.091,0,0,0-.391,1.341,2.032,2.032,0,0,0,.382,1.288,1.286,1.286,0,0,0,1.075.489,1.261,1.261,0,0,0,1.066-.489A2.066,2.066,0,0,0,75.845-17.664Z",
    transform: "translate(-61.118 24.482)",
    fill: "#3acb23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4723",
    "data-name": "Caminho 4723",
    d: "M2.1-17.7a14.753,14.753,0,0,1,1.741-.364,14.306,14.306,0,0,1,2.238-.169,5.452,5.452,0,0,1,1.981.311,2.975,2.975,0,0,1,1.252.879,3.426,3.426,0,0,1,.657,1.35,7.183,7.183,0,0,1,.2,1.741v5.276H7.518v-4.956a3.568,3.568,0,0,0-.338-1.812,1.377,1.377,0,0,0-1.261-.533q-.284,0-.6.027t-.568.062v7.212H2.1Zm16.752.036a4.064,4.064,0,0,1-.258,1.492,3.2,3.2,0,0,1-.711,1.11,3.124,3.124,0,0,1-1.093.7,3.84,3.84,0,0,1-1.4.249,3.84,3.84,0,0,1-1.4-.249,3.218,3.218,0,0,1-1.1-.7,3.131,3.131,0,0,1-.719-1.11,4.064,4.064,0,0,1-.258-1.492,4.189,4.189,0,0,1,.258-1.519,3.206,3.206,0,0,1,.719-1.128,3.153,3.153,0,0,1,1.1-.711,3.84,3.84,0,0,1,1.4-.249,3.84,3.84,0,0,1,1.4.249,3.063,3.063,0,0,1,1.093.711,3.273,3.273,0,0,1,.711,1.128A4.189,4.189,0,0,1,18.852-17.664Zm-2.025,0a2.161,2.161,0,0,0-.373-1.341,1.261,1.261,0,0,0-1.066-.489,1.292,1.292,0,0,0-1.066.489,2.091,2.091,0,0,0-.391,1.341,2.033,2.033,0,0,0,.382,1.288,1.286,1.286,0,0,0,1.075.489,1.261,1.261,0,0,0,1.066-.489A2.066,2.066,0,0,0,16.827-17.664Z",
    transform: "translate(52.437 24.482)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4725",
    "data-name": "Caminho 4725",
    d: "M1.95-21.166,4.6-21.592v2.753h3.18v2.2H4.6v3.286a2.614,2.614,0,0,0,.293,1.332,1.258,1.258,0,0,0,1.181.5,5.057,5.057,0,0,0,.879-.08,4.532,4.532,0,0,0,.826-.222L8.15-9.761a7.531,7.531,0,0,1-1.066.338,6.211,6.211,0,0,1-1.439.142,4.737,4.737,0,0,1-1.794-.293,2.815,2.815,0,0,1-1.137-.817,3.042,3.042,0,0,1-.6-1.27,7.5,7.5,0,0,1-.169-1.652Zm16.361,6.981a6.076,6.076,0,0,1-.32,2.016,4.381,4.381,0,0,1-.924,1.563,4.157,4.157,0,0,1-1.448,1,4.832,4.832,0,0,1-1.892.355A4.784,4.784,0,0,1,11.854-9.6a4.157,4.157,0,0,1-1.448-1,4.6,4.6,0,0,1-.942-1.563,5.786,5.786,0,0,1-.338-2.016,5.58,5.58,0,0,1,.346-2.007,4.552,4.552,0,0,1,.959-1.546,4.308,4.308,0,0,1,1.457-.995,4.69,4.69,0,0,1,1.839-.355,4.737,4.737,0,0,1,1.856.355,4.215,4.215,0,0,1,1.448.995,4.515,4.515,0,0,1,.942,1.546A5.712,5.712,0,0,1,18.311-14.185Zm-2.7,0a3.328,3.328,0,0,0-.489-1.927,1.6,1.6,0,0,0-1.395-.7,1.62,1.62,0,0,0-1.4.7,3.282,3.282,0,0,0-.5,1.927,3.368,3.368,0,0,0,.5,1.945,1.608,1.608,0,0,0,1.4.719,1.586,1.586,0,0,0,1.395-.719A3.415,3.415,0,0,0,15.611-14.185Zm4.654-6.981,2.647-.426v2.753h3.18v2.2h-3.18v3.286a2.614,2.614,0,0,0,.293,1.332,1.258,1.258,0,0,0,1.181.5,5.057,5.057,0,0,0,.879-.08,4.532,4.532,0,0,0,.826-.222l.373,2.061a7.531,7.531,0,0,1-1.066.338,6.211,6.211,0,0,1-1.439.142,4.737,4.737,0,0,1-1.794-.293,2.815,2.815,0,0,1-1.137-.817,3.042,3.042,0,0,1-.6-1.27,7.5,7.5,0,0,1-.169-1.652Zm11.192,9.824q.391,0,.746-.018a5.191,5.191,0,0,0,.568-.053v-2.007q-.16-.036-.48-.071a5.342,5.342,0,0,0-.586-.036,5.246,5.246,0,0,0-.7.044,1.833,1.833,0,0,0-.577.169.991.991,0,0,0-.391.338.941.941,0,0,0-.142.533.908.908,0,0,0,.417.862A2.307,2.307,0,0,0,31.457-11.342Zm-.213-7.745a6.13,6.13,0,0,1,1.954.266,3.035,3.035,0,0,1,1.252.764,2.807,2.807,0,0,1,.666,1.208,5.958,5.958,0,0,1,.2,1.581v5.507q-.568.124-1.581.293a15.193,15.193,0,0,1-2.452.169,7.772,7.772,0,0,1-1.643-.16,3.566,3.566,0,0,1-1.27-.524,2.4,2.4,0,0,1-.817-.95,3.28,3.28,0,0,1-.284-1.439,2.727,2.727,0,0,1,.329-1.386,2.529,2.529,0,0,1,.879-.906,3.974,3.974,0,0,1,1.261-.489,7.076,7.076,0,0,1,1.474-.151,8.371,8.371,0,0,1,.915.044,4.072,4.072,0,0,1,.648.115v-.249a1.465,1.465,0,0,0-.409-1.084,1.978,1.978,0,0,0-1.421-.409,9.049,9.049,0,0,0-1.332.1,5.715,5.715,0,0,0-1.137.275l-.338-2.132q.231-.071.577-.151t.755-.142q.409-.062.862-.107T31.244-19.088Zm10.2,9.77a6.613,6.613,0,0,1-1.874-.249,2.776,2.776,0,0,1-1.137-.648,2.151,2.151,0,0,1-.568-1.013,5.464,5.464,0,0,1-.151-1.341V-22.854l2.647-.426V-13.1a3.487,3.487,0,0,0,.053.64,1.1,1.1,0,0,0,.2.48,1.084,1.084,0,0,0,.435.32,2.385,2.385,0,0,0,.764.16Z",
    transform: "translate(114.286 25.302)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4722",
    "data-name": "Caminho 4722",
    d: "M0-10.83H8.882v2.2H0Z",
    transform: "translate(37.602 20.224)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4724",
    "data-name": "Caminho 4724",
    d: "M7.172-16.058a1.353,1.353,0,0,1-.462,1.119,1.623,1.623,0,0,1-1.048.373,1.623,1.623,0,0,1-1.048-.373,1.353,1.353,0,0,1-.462-1.119,1.353,1.353,0,0,1,.462-1.119,1.623,1.623,0,0,1,1.048-.373,1.623,1.623,0,0,1,1.048.373A1.353,1.353,0,0,1,7.172-16.058Zm0,7.195a1.353,1.353,0,0,1-.462,1.119,1.623,1.623,0,0,1-1.048.373,1.623,1.623,0,0,1-1.048-.373,1.353,1.353,0,0,1-.462-1.119,1.353,1.353,0,0,1,.462-1.119,1.623,1.623,0,0,1,1.048-.373,1.623,1.623,0,0,1,1.048.373A1.353,1.353,0,0,1,7.172-8.863Zm-5.7-4.708H9.819v2.221H1.47Z",
    transform: "translate(99.678 22.965)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5767-2",
    "data-name": "Grupo 5767",
    transform: "translate(17.468 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-12",
    "data-name": "Caminho 4715",
    d: "M490.387,233.994A4.392,4.392,0,1,0,486,238.386,4.4,4.4,0,0,0,490.387,233.994Z",
    transform: "translate(-478.297 -229.602)",
    fill: "#3acb16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-12",
    "data-name": "Caminho 4716",
    d: "M453.907,292.487h15.4a7.746,7.746,0,0,0-15.4,0Z",
    transform: "translate(-453.906 -275.796)",
    fill: "#3acb16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5768",
    "data-name": "Grupo 5768",
    transform: "translate(72.539 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-13",
    "data-name": "Caminho 4715",
    d: "M490.387,233.994A4.392,4.392,0,1,0,486,238.386,4.4,4.4,0,0,0,490.387,233.994Z",
    transform: "translate(-478.297 -229.602)",
    fill: "#fd4949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-13",
    "data-name": "Caminho 4716",
    d: "M453.907,292.487h15.4a7.746,7.746,0,0,0-15.4,0Z",
    transform: "translate(-453.906 -275.796)",
    fill: "#fd4949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5769",
    "data-name": "Grupo 5769",
    transform: "translate(161.269 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-14",
    "data-name": "Caminho 4715",
    d: "M490.387,233.994A4.392,4.392,0,1,0,486,238.386,4.4,4.4,0,0,0,490.387,233.994Z",
    transform: "translate(-478.297 -229.602)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-14",
    "data-name": "Caminho 4716",
    d: "M453.907,292.487h15.4a7.746,7.746,0,0,0-15.4,0Z",
    transform: "translate(-453.906 -275.796)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5770",
    "data-name": "Grupo 5770",
    transform: "translate(173.112 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-15",
    "data-name": "Caminho 4715",
    d: "M490.387,233.994A4.392,4.392,0,1,0,486,238.386,4.4,4.4,0,0,0,490.387,233.994Z",
    transform: "translate(-478.297 -229.602)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-15",
    "data-name": "Caminho 4716",
    d: "M453.907,292.487h15.4a7.746,7.746,0,0,0-15.4,0Z",
    transform: "translate(-453.906 -275.796)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5771",
    "data-name": "Grupo 5771",
    transform: "translate(184.955 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4715-16",
    "data-name": "Caminho 4715",
    d: "M490.387,233.994A4.392,4.392,0,1,0,486,238.386,4.4,4.4,0,0,0,490.387,233.994Z",
    transform: "translate(-478.297 -229.602)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4716-16",
    "data-name": "Caminho 4716",
    d: "M453.907,292.487h15.4a7.746,7.746,0,0,0-15.4,0Z",
    transform: "translate(-453.906 -275.796)",
    fill: "#4b4b4b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4726",
    "data-name": "Caminho 4726",
    d: "M10.661-8.675Q9.47-10.789,8.085-12.85a42.426,42.426,0,0,0-2.949-3.89v8.065H2.4V-20.986H4.656q.586.586,1.3,1.439T7.4-17.726q.737.968,1.466,2.007t1.368,2v-7.266h2.754V-8.675Zm8.865-12.453a7.7,7.7,0,0,1,4.228.968,3.509,3.509,0,0,1,1.474,3.171,3.558,3.558,0,0,1-1.492,3.206,7.723,7.723,0,0,1-4.263.986H18.6v4.121H15.83V-20.808a15.678,15.678,0,0,1,1.919-.249Q18.761-21.128,19.525-21.128Zm.178,2.363q-.3,0-.6.018t-.506.036v3.553h.87a4.717,4.717,0,0,0,2.167-.391,1.5,1.5,0,0,0,.728-1.457,1.748,1.748,0,0,0-.187-.853,1.418,1.418,0,0,0-.533-.542,2.4,2.4,0,0,0-.844-.284A6.97,6.97,0,0,0,19.7-18.765Zm10.925,7.976a4,4,0,0,0,.968-.1,1.785,1.785,0,0,0,.613-.266.892.892,0,0,0,.32-.4,1.425,1.425,0,0,0,.089-.515,1.19,1.19,0,0,0-.568-1,8.122,8.122,0,0,0-1.954-.862q-.6-.213-1.208-.489a4.453,4.453,0,0,1-1.084-.693,3.314,3.314,0,0,1-.782-1.013,3.172,3.172,0,0,1-.3-1.448,3.585,3.585,0,0,1,.32-1.537,3.281,3.281,0,0,1,.906-1.164,4.146,4.146,0,0,1,1.421-.737,6.379,6.379,0,0,1,1.883-.258A7.668,7.668,0,0,1,33.4-21a7.68,7.68,0,0,1,1.492.586l-.8,2.185a7.571,7.571,0,0,0-1.146-.471,4.962,4.962,0,0,0-1.519-.2,2.786,2.786,0,0,0-1.43.275.929.929,0,0,0-.435.844.975.975,0,0,0,.16.568,1.554,1.554,0,0,0,.453.417,3.986,3.986,0,0,0,.675.338q.382.151.844.311.959.355,1.67.7a4.46,4.46,0,0,1,1.181.808,2.927,2.927,0,0,1,.7,1.084,4.354,4.354,0,0,1,.231,1.51A3.207,3.207,0,0,1,34.27-9.377a5.83,5.83,0,0,1-3.642.95,10.09,10.09,0,0,1-1.474-.1,9.516,9.516,0,0,1-1.164-.24,6.674,6.674,0,0,1-.87-.3,6.609,6.609,0,0,1-.613-.3l.782-2.2a6.969,6.969,0,0,0,1.359.542A7.049,7.049,0,0,0,30.628-10.789Zm10.694-2.345h8.349v2.221H41.322Zm0-3.89h8.349V-14.8H41.322Z",
    transform: "translate(7.988 131.927)",
    fill: "#4b4b4b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4727",
    "data-name": "Caminho 4727",
    d: "M3.882-6.475a11.867,11.867,0,0,0,.642,3.906A13.251,13.251,0,0,0,6.208.764L4.4,1.927A12.7,12.7,0,0,1,2.129-1.927a12.877,12.877,0,0,1-.8-4.548,12.877,12.877,0,0,1,.8-4.548A12.7,12.7,0,0,1,4.4-14.877l1.805,1.163a13.251,13.251,0,0,0-1.684,3.333A11.867,11.867,0,0,0,3.882-6.475Z",
    transform: "translate(62.354 124.507)",
    fill: "#4b4b4b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4728",
    "data-name": "Caminho 4728",
    d: "M2.421-6.475a11.867,11.867,0,0,0-.642-3.906A13.251,13.251,0,0,0,.095-13.714L1.9-14.877a12.7,12.7,0,0,1,2.274,3.854,12.877,12.877,0,0,1,.8,4.548,12.877,12.877,0,0,1-.8,4.548A12.7,12.7,0,0,1,1.9,1.927L.095.764A13.251,13.251,0,0,0,1.779-2.569,11.867,11.867,0,0,0,2.421-6.475Z",
    transform: "translate(162.963 124.507)",
    fill: "#4b4b4b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4729",
    "data-name": "Caminho 4729",
    d: "M4.86-7.517l1.805-2.778H9.339L6.214-5.9Q7.255-4.6,8.106-3.368a20.868,20.868,0,0,1,1.354,2.2H6.683l-.347-.651Q6.127-2.2,5.867-2.63T5.32-3.481q-.286-.425-.564-.773-.26.33-.529.729t-.512.807q-.243.408-.477.807t-.408.746H.19A11.373,11.373,0,0,1,.763-2.187q.365-.59.79-1.224t.894-1.267q.469-.634.92-1.189Q2.586-6.961,1.8-8.081L.259-10.294H3.054Zm10.155-3.177q.5-.208,1.05-.477t1.068-.59q.521-.321,1-.677a6.852,6.852,0,0,0,.859-.755H20.8v12.03H18.209V-9.825a7.875,7.875,0,0,1-1.163.634q-.642.286-1.25.495ZM32.93-7.2a7.977,7.977,0,0,1-1.154,4.661A3.7,3.7,0,0,1,28.59-.92,3.7,3.7,0,0,1,25.4-2.543,7.977,7.977,0,0,1,24.251-7.2a10.621,10.621,0,0,1,.3-2.673,5.887,5.887,0,0,1,.877-1.962A3.907,3.907,0,0,1,26.8-13.054a3.807,3.807,0,0,1,1.788-.417,3.7,3.7,0,0,1,3.186,1.623A7.942,7.942,0,0,1,32.93-7.2Zm-2.639,0a14.124,14.124,0,0,0-.087-1.64,5.9,5.9,0,0,0-.278-1.276,1.98,1.98,0,0,0-.521-.833,1.179,1.179,0,0,0-.816-.3,1.147,1.147,0,0,0-.807.3,2.1,2.1,0,0,0-.521.833,5.554,5.554,0,0,0-.286,1.276,14.124,14.124,0,0,0-.087,1.64,14.353,14.353,0,0,0,.087,1.649,5.565,5.565,0,0,0,.286,1.285,2.1,2.1,0,0,0,.521.833,1.147,1.147,0,0,0,.807.3,1.179,1.179,0,0,0,.816-.3,1.98,1.98,0,0,0,.521-.833A5.913,5.913,0,0,0,30.2-5.555,14.352,14.352,0,0,0,30.292-7.2Zm12.5,0a7.977,7.977,0,0,1-1.154,4.661A3.7,3.7,0,0,1,38.451-.92a3.7,3.7,0,0,1-3.186-1.623A7.977,7.977,0,0,1,34.111-7.2a10.621,10.621,0,0,1,.3-2.673,5.887,5.887,0,0,1,.877-1.962,3.907,3.907,0,0,1,1.371-1.215,3.807,3.807,0,0,1,1.788-.417,3.7,3.7,0,0,1,3.186,1.623A7.942,7.942,0,0,1,42.791-7.2Zm-2.639,0a14.123,14.123,0,0,0-.087-1.64,5.9,5.9,0,0,0-.278-1.276,1.98,1.98,0,0,0-.521-.833,1.179,1.179,0,0,0-.816-.3,1.147,1.147,0,0,0-.807.3,2.1,2.1,0,0,0-.521.833,5.554,5.554,0,0,0-.286,1.276A14.124,14.124,0,0,0,36.75-7.2a14.353,14.353,0,0,0,.087,1.649,5.565,5.565,0,0,0,.286,1.285,2.1,2.1,0,0,0,.521.833,1.147,1.147,0,0,0,.807.3,1.179,1.179,0,0,0,.816-.3,1.98,1.98,0,0,0,.521-.833,5.913,5.913,0,0,0,.278-1.285A14.352,14.352,0,0,0,40.152-7.2Z",
    transform: "translate(278.471 124.386)",
    fill: "#4b4b4b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNpsExplanation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nps-explanation.f73c6670.svg";
export { ForwardRef as ReactComponent };